'use strict';

angular.module('chatEngine.submit', [
    'chatEngine.configuration'
])

.controller('SubmitCtrl', ['$scope', 'SUBMIT_BOT_NOTES_MAX_LENGTH',
    function($scope, SUBMIT_BOT_NOTES_MAX_LENGTH) {
    $scope.SUBMIT_BOT_NOTES_MAX_LENGTH = SUBMIT_BOT_NOTES_MAX_LENGTH;
    $scope.message = '';

    $scope.cancel = function() {
        $scope.$close({
            'submit': false
        });
    };

    $scope.submit = function() {
        $scope.$close({
            'submit': true,
            'message': $scope.message
        });
    };
}]);
